export const getNotificationTypeLabel = (type: string) => {
    switch (type) {
        case "tasks":
            return "tarefa";
        case "task_comments":
            return "comentário";
        case "notes":
            return "nota";
        default:
            return "";
    }
};

